import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";
import { IconButton } from "@mui/material";
import { useCallback, useState } from "react";
import { useFieldDestination } from "../../builder/common/fields/useFieldDestination.ts";

const spinKeyframes = {
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
};

interface Props {
  onRefresh: () => void;
  disabled?: boolean;
}

const RefreshGridButton = ({ onRefresh, disabled }: Props) => {
  const { stopAddingFields } = useFieldDestination();
  const [isRotating, setIsRotating] = useState(false);

  const refreshReport = useCallback(() => {
    setIsRotating(true);
    onRefresh();
    stopAddingFields();
    setTimeout(() => {
      setIsRotating(false);
    }, 500);
  }, [onRefresh, stopAddingFields]);

  return (
    <IconButton onClick={refreshReport} disabled={disabled}>
      <AutorenewRoundedIcon
        sx={(theme) => ({
          "&:hover": { color: theme.palette.primary.main },
          ...(isRotating && {
            animation: "spin 1s linear infinite",
            ...spinKeyframes,
          }),
        })}
      />
    </IconButton>
  );
};

export default RefreshGridButton;
